// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--2qW83","section":"styles-module--section--2C0Xy"};